module.exports = __webpack_public_path__ + "static/img_9680-fb8a4888a106e5aee580277f930e2345.webp";